import {createReducer} from "./index";

const authReducer = createReducer({
    state: 'signIn',
    data: {

    }
  },
  {
    // 'cproject/auth': (state, action) => {
    //   const { authState, authData } = action.payload;
    //   switch (authState) {
    //     case 'signedIn':
    //       return state
    //         .set('state', 'signedIn')
    //         .set('username', authData.username);
    //     case 'signIn':
    //       return state
    //         .set('state', 'signIn')
    //         .set('username', null);
    //     default:
    //       return state;
    //   }
    // },
    // 'cproject/recoverauth': (state, action) => {
    //   return state
    //     .set('state', 'signedIn')
    //     .set('username', action.payload.username);
    // },
    // '@@amplify/Hub/auth/signIn': (state, action) => {
    //   return state
    //     .set('state', 'signedIn')
    //     .set('username', action.payload.data.username);
    // },
    // '@@amplify/Hub/auth/signOut': (state, action) => {
    //   return state
    //     .set('state', 'signIn')
    //     .set('username', null);
    // }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth.js